const originalTextMap = new Map();

function isInsideExcludedTag(node) {
  const excludedTags = ['SCRIPT', 'STYLE', 'NOSCRIPT', 'SVG', 'CANVAS', 'IFRAME', 'OBJECT', 'EMBED', 'VIDEO', 'AUDIO'];
  let current = node;

  while (current) {
    if (excludedTags.includes(current.nodeName)) {
      return true;
    }
    current = current.parentNode;
  }
  return false;
}


function tokenizePreservingPunctuation(text) {
  return text.match(/[a-zA-Z]+|[^a-zA-Z\s\d]+|\s+|\d+/g) || [];
}

function matchCase(original, replacement = "meow") {
  if (original.toUpperCase() === original) {
    return replacement.toUpperCase();
  }
  if (
    original[0].toUpperCase() === original[0] &&
    original.slice(1).toLowerCase() === original.slice(1)
  ) {
    return replacement[0].toUpperCase() + replacement.slice(1).toLowerCase();
  }
  return replacement.toLowerCase();
}

function replaceWithMeowsPreservingCaseAndPunctuation(text) {
  const tokens = tokenizePreservingPunctuation(text);

  return tokens.map((token) => {
    if (/^[a-zA-Z]+$/.test(token)) {
      const meowCount = Math.max(Math.round((token.length / 4.0) - 0.01), 1);
      const meows = "meow ".repeat(meowCount);
      return matchCase(token, meows.trimEnd());
    }
    return token;
  }).join("");
}

function meowifySequenceText() {
  document.querySelectorAll('.png-sequence__title').forEach((el) => {
    if (el.hasAttribute('meowified')) return;
    el.setAttribute('meowified', '');
    el.innerHTML = '';
    const newText = replaceWithMeowsPreservingCaseAndPunctuation(el.getAttribute('data-text') || '');
    const words = newText.split(' ');
    words.forEach((word) => {
      const div = document.createElement('div');
      const chars = word.split('');
      chars.forEach((char) => {
        const span = document.createElement('span');
        span.textContent = char;
        div.appendChild(span);
      });
      el.appendChild(div);
    });
  });
}

function restoreMeowifiedSequenceText() {
  document.querySelectorAll('.png-sequence__title').forEach((el) => {
    el.removeAttribute('meowified');
    el.innerHTML = '';
    const newText = el.getAttribute('data-text') || '';
    const words = newText.split(' ');
    words.forEach((word) => {
      const div = document.createElement('div');
      const chars = word.split('');
      chars.forEach((char) => {
        const span = document.createElement('span');
        span.textContent = char;
        div.appendChild(span);
      });
      el.appendChild(div);
    });
  });
}

function meowify(selector = "[data-meowify]") {
  const elements = document.querySelectorAll(selector);

  elements.forEach((el) => {
    const walker = document.createTreeWalker(
      el,
      NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT,
      null,
      false
    );

    let node;
    while ((node = walker.nextNode())) {
      if (
        node.nodeType === Node.TEXT_NODE
        && node.nodeValue.trim()
        && !isInsideExcludedTag(node)
        && (!originalTextMap.has(node) || originalTextMap.get(node) == node.nodeValue || !node.nodeValue.toLowerCase().includes('meow'))
      ) {
        originalTextMap.set(node, node.nodeValue);
        node.nodeValue = replaceWithMeowsPreservingCaseAndPunctuation(node.nodeValue);
      } else if (node.nodeType === Node.ELEMENT_NODE && el.matches('input[placeholder], textarea[placeholder]')) {
        const placeholder = node.getAttribute('placeholder');
        if (placeholder.trim() && (!originalTextMap.has(placeholder) || originalTextMap.get(node) == placeholder || !placeholder.toLowerCase().includes('meow'))) {
          originalTextMap.set(node, placeholder);
          node.setAttribute('placeholder', replaceWithMeowsPreservingCaseAndPunctuation(placeholder));
        }
      }
    }
    
    if (el.matches('input[placeholder], textarea[placeholder]')) {
      const placeholder = el.getAttribute('placeholder');
      if (placeholder.trim() && (!originalTextMap.has(placeholder) || originalTextMap.get(el) == placeholder || !placeholder.toLowerCase().includes('meow'))) {
        originalTextMap.set(el, placeholder);
        el.setAttribute('placeholder', replaceWithMeowsPreservingCaseAndPunctuation(placeholder));
      }
    }
  });

  meowifySequenceText();
  meowifyScrollingText();

  scaleLargeText();
  renderAccordions();
}

function restoreMeowifiedText() {
  for (const [node, originalText] of originalTextMap.entries()) {
    if (node instanceof HTMLInputElement || node instanceof HTMLTextAreaElement) {
      node.setAttribute('placeholder', originalText);
    } else {
      node.nodeValue = originalText;
    }
  }
  originalTextMap.clear();

  restoreMeowifiedSequenceText();
  populateScrollingText();

  scaleLargeText();
  renderAccordions();
}

function meowifyScrollingText() {
  document.querySelectorAll(`.scrolling-text`).forEach((el) => {
    el.innerHTML = '';
    const text = replaceWithMeowsPreservingCaseAndPunctuation(el.getAttribute('data-text'));
    const speed = parseFloat(el.getAttribute('data-speed'));

    var textEl = document.createElement('span');
    textEl.innerText = text;
    el.appendChild(textEl);

    var speedScale = textEl.clientWidth / 100;
    el.style.animationDuration = `${speed * speedScale}s`;

    var numEls = Math.ceil(el.parentElement.clientWidth / textEl.clientWidth) + 2;

    for (var i = 0; i < numEls; i++) {
      const textElClone = textEl.cloneNode(true);
      textElClone.setAttribute('aria-hidden', 'true');
      el.appendChild(textElClone);
    }
  });
}